module.exports = __webpack_public_path__ + "static/media/bri-delph.47e8fbcf.jpeg";